import { render, staticRenderFns } from "./LabelTag.vue?vue&type=template&id=32af58f6&scoped=true"
import script from "./LabelTag.vue?vue&type=script&lang=ts"
export * from "./LabelTag.vue?vue&type=script&lang=ts"
import style0 from "./LabelTag.vue?vue&type=style&index=0&id=32af58f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af58f6",
  null
  
)

export default component.exports